module.exports = __webpack_public_path__ + "static/media/petzenpro-1.3294e1e7.jpg";